<template>
    <nav class="in-page-nav d-none d-md-block">
        <ul>
            <li v-for="link in links">
                <a class="in-page-nav-link" :class="[ link.hash === active ? 'active' : '' ]" :href="link.hash" @click.prevent="scrollTo(link.hash)">
                    <span class="in-page-nav-link-title">{{ link.title }}</span>
                    <span class="in-page-nav-link-dot"></span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    import { scrollTo } from '@/helpers/utils'

    export default {
      props: {
        active: {
          type: String
        },
        links: {
          type: Array,
          required: true
        }
      },
      methods: {
        scrollTo (target) {
          const $target = document.querySelector(target)

          let offset = window.innerHeight / 3

          if ($target.clientHeight <= (window.innerHeight - offset)) {
            offset = (window.innerHeight - $target.clientHeight) / 2
          }

          scrollTo($target, -offset)
        }
      }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .in-page-nav {
        font-size: px2rem(12px);
        font-style: italic;
        padding: 0;
        position: fixed;
        right: 2rem;
        text-align: right;
        transform: translateY(-50%);
        top: 50%;

        > ul {
            list-style: none;
            padding: 0;
            margin: 0;

            > li {
                margin-bottom: px2rem(40px);

                @include media-breakpoint-up(xl) {
                    margin-bottom: px2rem(60px);
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        &-link {
            color: #585858;
            display: block;
            padding: 0.5rem;
            transition: color .25s ease-in-out;

            &-title {
                display: inline-block;
                margin-right: px2rem(10px);
                opacity: 0;
                transition: opacity .25s ease-in-out, transform .25s ease-in-out, visibility .25s ease-in-out;
                transform: scale(0.7);
                transform-origin: right center;
                visibility: hidden;
            }

            &-dot {
                background-color: white;
                border-radius: 100%;
                display: inline-block;
                height: 12px;
                transition: background-color .25s ease-in-out;
                vertical-align: middle;
                width: 12px;
            }

            &.active {
                color: #c21333;

                .in-page-nav-link-link {
                    opacity: 1;
                    transform: scale(1);
                    visibility: visible;
                }

                .in-page-nav-link-dot {
                    background-color: #c21333;
                }
            }

            &:hover {
                color: #c21333;

                .in-page-nav-link-dot {
                    background-color: #c21333;
                }
            }
        }

        &:hover {
            .in-page-nav-link-title {
                opacity: 1;
                transform: scale(1);
                visibility: visible;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// InPageNav.vue?b2f302c4